<app-modal
  #modal
  [modalConfig]="{
    titleText: 'Previous Submissions',
    options: { size: 'xl' },
    headerClass: ['modal-header', 'bg-primary', 'text-white', 'border-0'],
    bodyClass: ['submission-body', 'p-0'],
    customFooter: true
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="modal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div class="w-100" style="background-color: #fff; min-height: 500px">
    <ng-container *ngIf="sessionSubmissionsData">
      <ng-container *ngIf="currentSubmission; else loadingTemplate">
        <div class="submission-toolbar">
          <div class="button-bar">
            <button
              *ngIf="sessionSubmissionsData.length > 1"
              ngbTooltip="Previous submission"
              placement="bottom"
              class="btn sub-btn-arrow p-1"
              (click)="goToSubmission('previous')"
              [disabled]="currentSubmissionIdx === 0">
              <i class="bi bi-chevron-left"></i>
            </button>

            <button
              *ngIf="sessionSubmissionsData.length > 1"
              ngbTooltip="Next submission"
              placement="bottom"
              class="btn sub-btn-arrow p-1"
              (click)="goToSubmission('next')"
              [disabled]="
                currentSubmissionIdx === sessionSubmissionsData.length - 1
              ">
              <i class="bi bi-chevron-right"></i>
            </button>

            <div class="page-numbers">
              {{ currentSubmissionIdx + 1 }} of
              {{ sessionSubmissionsData.length }}
            </div>
          </div>
          <div class="info-content">
            <div class="sub-text">
              <strong class="me-2">Session: </strong>
              <button
                (click)="openSession(currentSubmission.submission)"
                class="btn btn-link fs-17 fw-700">
                {{ currentSubmission.session.title }}
              </button>
            </div>
            <div
              *ngIf="
                currentSubmission && currentSubmission.submission.created_at
              "
              class="sub-text">
              <strong class="me-2">Date:</strong>
              {{ currentSubmission.submission.created_at | formatDate }}
            </div>
          </div>
        </div>

        <div class="submission-content">
          <div class="form-wrapper-shadow">
            <app-proforms-form
              [formId]="currentSubmission.form.id"
              [submissionId]="currentSubmission.submission.id"
              [viewState]="viewStates.GRADED" />
          </div>
        </div>
      </ng-container>

      <ng-template #loadingTemplate>
        <div class="w-100" style="background-color: #fff; height: 400px">
          <app-loader></app-loader>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <div footerContent>
    <button
      type="button"
      class="btn btn-md btn-primary"
      (click)="modal.close()">
      Done
    </button>
  </div>
</app-modal>
